import './include/register-service-worker';
import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';

import $ from 'jquery'; // Static
import Cookies from './vendor/cookie'; // Static

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
branchBar.init();

$(function() {

  var $evenHeights = $('.even-height'),
    resizeTimeout,
    breakingPoints = {
      '767': 'sm',
      '991': 'md',
      '1198': 'lg'
    },
    /*headingMargin = {
      'xs': 100,
      'sm': 100,
      'md': 100,
      'lg': 125
    },*/
    desktopDevices = ['sm', 'md', 'lg'],
    device = 'xs',
    desktop = false;

  if ($('.equal-height-target').length) {
    import('./include/equal-height.js');
  }

  if (typeof Cookies.get('popupShown') === 'undefined') {
    import('featherlight').then(() => {
      if ($('#popup-notice').length && $('body.editor').length === 0) $.featherlight($('#popup-notice'), { variant: 'featherlight-popup', afterClose: function() { $('#popup-notice').hide(); } });
      Cookies.set('popupShown', '1', { expires: 365 });
    });
  }

  if (typeof Cookies.get('checkCookies') === 'undefined') {
    var $cookieConsent = $('.cookie-consent').fadeIn();

    $($cookieConsent).on('click', 'button', function(e) {
      e.preventDefault();

      Cookies.set('checkCookies', 'done', { expires: 365 });
      $cookieConsent.remove();
    });
  }

  /**
   * PopUp for russian contacts
   */
  const rusPrivacyButton = document.querySelectorAll('.contact-privacy-russia');
  const rusPrivacyTemplate = document.getElementById('russian-notice');
  if (rusPrivacyButton.length && rusPrivacyTemplate) {
    import('./include/contact-info-russia').then(module => {
      const contactInfo = module.default;
      contactInfo.init();
    })

  }

  /**
    * Before you go PopUp
  */
  const beforeYouGo = document.getElementById('before-you-go');
  if (beforeYouGo) {
    import('./include/before-you-go.js').then( module => {
      const before = module.default;
      before.init();
    })
  }

  $('button.pdf').on('click', function(e) {

    e.preventDefault();

    var $button = $(this);
    var options = JSON.parse(decodeURIComponent($button.data('options')));

    // Load dynamically pdf module
    import('./include/pdf').then(({ default: Pdf }) => {
      Pdf.create($button, options.lang, options.pages);
    });

  });

  function detectDevice() {
    device = 'xs';
    desktop = false;

    var ww = window.innerWidth;

    for (var key in breakingPoints) {
      if (ww > key) {
        device = breakingPoints[key];
      }
    }

    if (desktopDevices.indexOf(device) !== -1) {
      desktop = true;
    }
  }

  if ($('.primary-event-title').length && $('.primary-event-title')[0].offsetHeight > 35) {

    $('.primary-event-title').addClass('twoline');

  }

  detectDevice();

  function headerTitleBorder() {

    var $children = $('h1 span');
    var titleBottomOffset = 0;

    $.each($children, function(index, child) {

      var $child = $(child);

      if ($child.html().indexOf('-') !== -1) {
        $child.css('whiteSpace', 'nowrap');
      }

    });

    $.each($children, function(index, child) {

      var $child = $(child);
      var offsetTop = $child.offset().top;

      titleBottomOffset = Math.max(offsetTop, titleBottomOffset);

    });

    $.each($children, function(index, child) {
      /*
      * H1 bottom row underline
      */
      var $child = $(child);
      var offsetTop = $child.offset().top;

      if (offsetTop === titleBottomOffset) {
        $child.addClass('bottom');
      } else {
        $child.removeClass('bottom');
      }
    });

    $('h1').addClass('spanfix');
  }

  headerTitleBorder();

  setTimeout(headerTitleBorder, 150);

  function headingCenter() {
    //Don't do this on pages marked specifically
    if ($('body').is('.no-heading-center')) { return; }

    var $header = $('header'),
      $nav = $('header nav'),
      $h1 = $('header h1'),
      $h3 = $h1.next();

    // Reset margin-top before calculation
    $h1.css('marginTop', '10px');

    var headerHeight = $header.prop('offsetHeight'),
      navOffset = $nav.length ? $nav.offset().top + $nav.prop('offsetHeight') : 0,
      h1Height = $h1.prop('offsetHeight'),
      h3Offset = $h3.length ? $h3.offset().top : 0,
      h3Height = $h3.length ? headerHeight - h3Offset : 0,
      h1Margin = (((headerHeight - navOffset) - h3Height) / 2) - (h1Height / 2);

    if (device !== 'xs') {
      $h1.css('marginTop', Math.max(10, h1Margin) + 'px');
    }
  }

  function doEvenHeights() {
    $.each($evenHeights, function(i, item) {
      $(item).css('height', 'auto');
    });

    if (desktop) {
      $.each($evenHeights, function(i, item) {
        /*
        * Even height elements
        */
        var $el = $(item),
          $parent = $el.parent(),
          $items = $parent.children(),
          maxSiblingHeight = 0;

        $.each($items, function(ii, item2) {
          maxSiblingHeight = Math.max(maxSiblingHeight, $(item2).height());
        });

        $el.css('height', maxSiblingHeight + 'px');
      });
    }
  }

  if (desktop) {

    doEvenHeights();
    headingCenter();

  }

  // Tab hash change
  var $tabs = $('.application-line-tab label');

  if ($tabs.length) {
    // ignore first

    $tabs.on('click', tabHandler);

    // If hash is set, open corresponding tab
    if (window.location.hash) {
      var hash = window.location.hash.replace(/[0-9]+/g, ' ').split(' ').pop(); // We only need the ending: enter, extend or explore.


      if ($.inArray(hash, ['enter', 'extend', 'explore']) === -1) {

        hash = window.location.hash.replace('#', '');

      }

      var $input = $('#tabs-' + hash);

      if ($input.length) {

        $input.prop('checked', true).trigger('change');

      }

    }
  }

  function tabHandler(e) {
    var target = e.target;

    if (target.parentNode.tagName.toLowerCase() !== 'div') {
      target = target.parentNode;
    }

    var hash = typeof target.dataset.hash !== 'undefined' ? target.dataset.hash : '';
    document.location.hash = hash;
  }

  if ($('.accordion').length) {
    /*
  * Enable input[type="radio"] to uncheck
  */
    var $hideToggles = $('label:has(.hide-toggle)')

    $hideToggles.on('click', function(e) {
      var id = $(this).attr('for'),
        $input = $('#' + id),
        self = this;

      if ($input.prop('checked')) {
        e.preventDefault();
        e.stopPropagation();
        $input.prop('checked', false);
      } else {
        setTimeout(function() {
          var top = $(self).offset().top,
            bodyScrollTop = $('body').prop('scrollTop');

          /* eslint-disable */
          if (false && bodyScrollTop > top) {
            $('html').prop('scrollTop', top);
            $('body').porp('scrollTop', top);
          }
          /* eslint-enable */
        }, 10);
      }
    });
  }

  if ($('.tab-trigger').length) {
    /*
  * Enable input[type="radio"] to uncheck
  */

    $('.tab-trigger').on('click', function(e) {
      if (device === 'xs') {
        var id = $(this).attr('for'),
          $input = $('#' + id),
          self = this;

        if ($input.is(':checked')) {
          e.preventDefault();
          e.stopPropagation();
          $input.prop('checked', false);
        } else {
          setTimeout(function() {
            var top = $(self).offset().top,
              bodyScrollTop = $('body').prop('scrollTop');

            /* eslint-disable */
            if (false && bodyScrollTop > top) {
              $('html').prop('scrollTop', top);
              $('body').prop('scrollTop', top);
            }
            /* eslint-enable */
          }, 10);
        }
      }
    });
  }

  $('.emparse').each(function(i, el) {

    var $el = $(el);
    var email = $el.html().replace('/', '@').split(';').reverse().join('');

    $el.html(email).attr('href', 'mailto:' + email);
  });

  if (document.location.hash !== '' && $(document.location.hash).length) {

    var $el = $(document.location.hash);
    var tag = $el.prop('tagName');

    switch (tag) {
    case 'INPUT':
      $el.prop('checked', true);

      setTimeout(function() {
        var top = $el.offset().top,
          bodyScrollTop = $('body').prop('scrollTop');

        if (bodyScrollTop > top) {
          $('html').prop('scrollTop', top);
          $('body').prop('scrollTop', top);
        }
      }, 10);
      break;
    }

  }

  $(document).on('change', '#change-country-drawer', function(e) {

    var $drawer = $(this);

    if ($drawer.is(':checked')) {

      $('#country-input').focus();
      $('.search-btn').click();
      $('.drawer-results-list').html('');

    }

  });

  var lastCountryValue = '';

  /* eslint-disable */
  $(document).on('keyup change', '#country-input', function(e) {

    var $input = $(this);
    var val = $input.val(),
      l = val.length,
      matches = [],
      $matchesContainer = $('.drawer-results-list'),
      $countryOptions = $('.country-option'),
      keyCode = e.which;

    if (keyCode === 27) {
      // ESC
      $('#country-input').val('');
      $('#country-input').blur();

      val = '';
      lastCountryValue = '';

      $countryOptions.remove();

      $('#change-country-drawer').prop('checked', false);

    } else if (val !== lastCountryValue) {

      lastCountryValue = val;

      for (const key in countryCodes) {
        if (countryCodes[key].toLowerCase().substr(0, l) === val.toLowerCase()) {
          matches.push(key);
        }
      }

      $matchesContainer.html('');
      matches.sort();

      if (matches.length > 0 && val !== '') {
        matches.forEach(function(match) {
          var href = document.location.pathname + '?setcountry=' + match;

          $matchesContainer.append('<a href="' + href + '" class="country-option">' + countryCodes[match] + '</a>');
        });
      }
    }
  });
  /* eslint-enable */

  $(document).on('click', '.share-email', function(e) {

    e.preventDefault();

    $('body').toggleClass('email-share');

  });

  $(document).on('click', '.cancel-share', function(e) {

    e.preventDefault();

    $('body').toggleClass('email-share');

  });

  $(window).on('resize', function() {

    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(function() {

      headerTitleBorder();
      detectDevice();
      headingCenter();
      doEvenHeights();

    }, 200);

  });

  $(document).on('click', '.navigation-parent', function(e) {

    if ($(this).attr('href') === '#') {

      e.preventDefault();

    }

  });

  if (!window.location.origin) {
    window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
  }

  /*function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }*/

  $(document).on('click', '.search-btn', function(e) {

    e.preventDefault();

    var $searchToggle = $('#search-drawer');

    $searchToggle.prop('checked', !$searchToggle.is(':checked'));

    if (!$searchToggle.is(':checked')) {

      $('.drawer-results-list').html('');
      $('body').prop('scrollTop', 0);

    }

  });

  window.onload = function() {
    if ($('.background-image').length === 2) {
      $('header').addClass('play');
    }
  };

  // Make the parent elements clickable
  $('.container [data-parent-href]').on('click', function(e) {
    var $el = $(this);
    // Change components table behaviour in mobile
    if (device === 'xs' && $el.parent().hasClass('components-table')) {
      if (!$el.hasClass('expanded') || ($el.hasClass('expanded') && e.target.nodeName !== 'A'))
        $(this).toggleClass('expanded');
    } else {
      window.location.href = $el.data('parentHref');
    }
  });

  if ($('.components-table').length) {
    //require('./include/component-table.js');
    import('./include/component-table.js');
  }

  // Component upgrades toggle functionality
  $('.component-upgrades-header').on('click', function() {
    $(this).parent().toggleClass('open');
  });

  // Activate video elements on click
  /*$('.video-embed--thumbnail').on('click', function(event){
    event.preventDefault();

    var $videoElement = $(this),
        $img = $videoElement.find('.youtube-thumbnail'),
        src = $videoElement.data('src'),
        iframeHtml = $('<iframe src="' + src + '" \
                                style="width:100%;height:'+ $img.height +'px;border:0px;"\
                                webkitallowfullscreen="true"\
                                mozallowfullscreen="true"\
                                allowfullscreen="true"></iframe>');

    $videoElement.addClass(' open-video').html('').before(iframeHtml);
  });*/

  setArrowHeights();
  window.addEventListener('resize', setArrowHeights, false);

  function setArrowHeights() {
    $('.timeline-like-list-arrow').each(function(i, arrow) {

      var $arrow = $(arrow);

      $arrow.css('height', 'auto');

      var $icon = $arrow.parent().find('.timeline-like-list-icon');

      if ($icon.length) {
        var $nextElement = $arrow.parent().next();

        while ($nextElement.length && !$nextElement.hasClass('timeline-like-list-item') && $nextElement.next().length) {
          $nextElement = $nextElement.next();
        }

        if ($nextElement.length && $nextElement.hasClass('timeline-like-list-item')) {
          var iconBottom = $icon.offset().top + $icon.height();
          var nextElementTop = $nextElement.offset().top;

          $arrow.css('height', Math.round(Math.max((nextElementTop - iconBottom) + 30, 50)) + 'px');
        }
      }
    });
  }


  if ($('.consultation-filters').length) {
    import('./include/consultation-filter.js');
  }

  if ($('.consultation-product-images').length) {
    import('./include/consultation.js');
  }

  if ($('form#review-form').length) {
    import('./include/review.js');
  }

  if ($('.material-download').length) {
    import('./include/material-download.js');
  }

  if ($('.news-wall').length) {
    import('./include/news-wall');
  }

  if ($('.lazy').length) {
    import('./include/lazyloader').then(({ default: Lazyloader }) => {
      Lazyloader.init();
    });
  }
});
